module.exports = __webpack_public_path__ + "static/media/sohananime.e0cc472a.png";